import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/resultCard.css';
import ResultCardRacing from './resultCardRacing';
import ResultCardFootball from './resultCardFootball';
import ResultCardBasketball from './resultCardBasketball';
import ResultCardAF from './resultCardAF';
import ResultCardMatchday from './resultCardMatchday';
import {
    AMERICAN_FOOTBALL_MODULE,
    BASEBALL_MODULE,
    BASKETBALL_MODULE,
    CRICKET_MODULE,
    FOOTBALL_MODULE,
    MATCHDAY_MODULE,
    RACING_MODULE,
    TENNIS_MODULE
} from '../../../constants/identifiers';
import {getModuleFromEventType} from '../../../helpers/moduleHelpers';
import {ASSETS_URL} from "../../../constants/endpoints";
import {getGameFromChannel} from "../helpers/gameHelpers";
import ResultCardCricket from "./resultCardCricket";
import ResultCardTennis from './resultCardTennis';
import ResultCardBaseball from './resultCardBaseball';
import ResultCardTextBasedMatchday from './resultCardTextBasedMatchday';
import {isTextBasedGame} from "../modules/matchday/helpers/matchdayHelper";

const mapStateToProps = (state, ownProps) => {
    return {
        games: state.vpp.games,
        selectedGameIndex: state.vpp.selectedGameIndex,
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp
    };
};

class ResultCard extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            games: storeData.vpp.games,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events
        };
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                games: storeData.vpp.games,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                events: storeData.vpp.events,
            });
        }
    }

    render() {

        let store = this.props.store;
        let storeData = store.getState();

        let selectedEvent = (this.state.events && this.state.events.length && this.state.games[this.state.selectedGameIndex].channel === this.state.events[this.state.selectedEventIndex].channel)
            ? this.state.events[this.state.selectedEventIndex]
            : undefined;
        let gameCard;
        let channelName = this.state.games[this.state.selectedGameIndex].channel;

        if (storeData.vpp.nextEventsTimeStamp.find((event) => event.channel === storeData.vpp.games[this.state.selectedGameIndex].channel && Number(event.eventTime)) === undefined) {
            console.log('no future events');
            return '';
        }
        let backgroundImageUrl;
        if (selectedEvent) {
            let module = getModuleFromEventType(selectedEvent.eventType);

            switch (module) {
                case RACING_MODULE:
                    gameCard = (<ResultCardRacing id='resultCard_racingCard' store={this.props.store}/>);
                    break;
                case FOOTBALL_MODULE:
                    gameCard = (<ResultCardFootball id='resultCard_footballCard' store={this.props.store}/>);
                    break;
                case BASKETBALL_MODULE:
                    gameCard = (<ResultCardBasketball id='resultCard_basketballCard' store={this.props.store}/>);
                    break;
                case AMERICAN_FOOTBALL_MODULE:
                    gameCard = (<ResultCardAF id='resultCard_AFCard' store={this.props.store}/>);
                    break;
                case MATCHDAY_MODULE:
                    if(!isTextBasedGame(channelName))
                        gameCard = (<ResultCardMatchday id='resultCard_MatchdayCard' store={this.props.store}/>);
                    else
                        gameCard = (<ResultCardTextBasedMatchday id='resultCard_MatchdayTextCard' store={this.props.store}/>);
                    break;
                case CRICKET_MODULE:
                    gameCard = (<ResultCardCricket id='resultCard_CricketCard' store={this.props.store}/>);
                    break;
                case TENNIS_MODULE:
                    gameCard = (<ResultCardTennis id='resultCard_TennisCard' store={this.props.store}/>);
                    break;
                case BASEBALL_MODULE:
                    gameCard = (<ResultCardBaseball id='resultCard_BaseballCard' store={this.props.store}/>);
                    break;
                default:
                    gameCard = (<div></div>);
                    break;
            }

            backgroundImageUrl = `${ASSETS_URL}${getGameFromChannel(selectedEvent.channel, this.state.games).assetsPath}/backplate.png`;
        }
        return (
            <div className={style.mainContainer} style={{backgroundImage: `url(${backgroundImageUrl})`}}>
                {gameCard}
            </div>
        );
    }
}

export default connect(mapStateToProps)(ResultCard);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/resultCard.js